
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M8 3.23c-3.057 0-5.83 1.673-7.875 4.39a.633.633 0 000 .756c2.046 2.72 4.818 4.392 7.875 4.392 3.057 0 5.83-1.673 7.875-4.39a.633.633 0 000-.755C13.829 4.903 11.057 3.23 8 3.23zm.22 8.127A3.367 3.367 0 014.641 7.78 3.373 3.373 0 017.78 4.64a3.367 3.367 0 013.577 3.578 3.383 3.383 0 01-3.139 3.138zm-.102-1.551A1.81 1.81 0 016.193 7.88 1.82 1.82 0 017.885 6.19 1.81 1.81 0 019.81 8.114a1.82 1.82 0 01-1.692 1.692z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    